var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tab4"}},[_c('h1',[_vm._v("Tab 4")]),_c('p',[_vm._v("Example tab menu 4 case is long name design system test.")])])
}]

export { render, staticRenderFns }